import { auth } from '../firebase/firebase-config';

async function authedFetch(route, body) {
  const user = auth.currentUser;
  if (!user) throw new Error('Please sign in again.');
  const token = await user.getIdToken();
  const res = await fetch(route, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify(body || {}),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || 'Something went wrong — please try again.');
  return data;
}

export const getWorkspace = () => authedFetch('/api/desk/workspace');
export const listContracts = (workspaceId) => authedFetch('/api/desk/contracts', { workspaceId });
export const getContract = (workspaceId, contractId) => authedFetch('/api/desk/contract', { workspaceId, contractId });
export const uploadContract = (workspaceId, filename, fileBase64) =>
  authedFetch('/api/desk/contract-upload', { workspaceId, filename, fileBase64 });
export const deleteContract = (workspaceId, contractId) =>
  authedFetch('/api/desk/contract-delete', { workspaceId, contractId });
export const correctFact = (workspaceId, contractId, factKey, status, editedText, note) =>
  authedFetch('/api/desk/fact-correct', { workspaceId, contractId, factKey, status, editedText, note });

export const createTask = (workspaceId, contractId, { factKey, text, dueDate, category, page }) =>
  authedFetch('/api/desk/task-create', { workspaceId, contractId, factKey, text, dueDate, category, page });
export const listContractTasks = (workspaceId, contractId) =>
  authedFetch('/api/desk/tasks', { workspaceId, contractId });
export const listWorkspaceOpenTasks = (workspaceId) =>
  authedFetch('/api/desk/tasks-open', { workspaceId });
export const setTaskStatus = (workspaceId, contractId, taskId, done) =>
  authedFetch('/api/desk/task-status', { workspaceId, contractId, taskId, done });
export const updateTaskDueDate = (workspaceId, contractId, taskId, dueDate) =>
  authedFetch('/api/desk/task-due-date', { workspaceId, contractId, taskId, dueDate });
export const deleteTask = (workspaceId, contractId, taskId) =>
  authedFetch('/api/desk/task-delete', { workspaceId, contractId, taskId });
